import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _entities = [];

let ProgrammeStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _entities;
    },
    getById: function(id) {
        return _entities.find(function(e) {
            return e !== undefined && e.id == id;
        });
    },
    add: function(entity) {
        // check if the programme already exists in the collection
        let index = _entities.findIndex(function(e) {
            return e !== undefined && e.id == entity.id;
        });
        if(index >= 0) {
            _entities[index] = entity;
        } else {
            _entities.push(entity);
        }
    },
    update: function(entity) {
        // deprecated; add does update and insert as well.
        this.add(entity);
    },
    delete: function(programmeId, success) {
        let index = _entities.findIndex(function(e) {
            return e !== undefined && e.id == programmeId;
        });
        if (0 <= index) {
            if (success) {
                delete _entities[index];
            } else if (_entities[index].loading) {
                _entities[index].loading = undefined;
            }
        }
    },
});

ProgrammeStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.PROGRAMME_LIST:
            _entities = action.data;
            ProgrammeStore.emitChange();
            break;

        case ActionTypes.PROGRAMME_LIST_ERROR:
            ProgrammeStore.emitChange();
            break;

        case ActionTypes.PROGRAMME_INFO:
            ProgrammeStore.add(action.data);
            ProgrammeStore.emitChange();
            break;

        case ActionTypes.PROGRAMME_INFO_ERROR:
            ProgrammeStore.emitChange();
            break;

        case ActionTypes.PROGRAMME_UPDATE:
            ProgrammeStore.add(action.data);
            ProgrammeStore.emitChange();
            break;

        case ActionTypes.PROGRAMME_DELETE:
            ProgrammeStore.delete(action.data.programmeId, action.data.success);
            ProgrammeStore.emitChange();
            break;

        case ActionTypes.PROGRAMME_SAVE:
            ProgrammeStore.add(action.data);
            ProgrammeStore.emitChange();
            break;

        default:
            break;

    }

});

export default ProgrammeStore;
